import { render, staticRenderFns } from "./PopUploadDemo.vue?vue&type=template&id=9bf37534&scoped=true&"
import script from "./PopUploadDemo.vue?vue&type=script&lang=js&"
export * from "./PopUploadDemo.vue?vue&type=script&lang=js&"
import style0 from "./PopUploadDemo.vue?vue&type=style&index=0&id=9bf37534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf37534",
  null
  
)

export default component.exports